/*
  Zentraler Klaviyo-Newsletter-Handler (site-weit via layout/theme.liquid geladen).
  Routet ALLE Newsletter-Eintritte ueber die Klaviyo Client-API mit Double-Opt-in
  (Liste WF4XTC) und haengt signup_source an. Kein Shopify-Dual-Write mehr.
  Zusaetzlich: UTM-Herkunft der Sitzung als signup_utm_* / signup_landing_path
  ins Profil; nach Erfolg GA4-Event newsletter_signup (nur mit Consent).

  Zwei Formular-Familien:
   1) [data-brief-inline]  -> "der Brief" (Startseite/Collections via brief-browse,
      Artikel via brief-inline). Optional zweistufig (data-brief-cta). Quelle aus data-source.
   2) form.newsletter-form -> Theme-Formulare (Header-Popup, Footer, Newsletter-Section,
      Popup). Quelle aus DOM-Kontext.
*/
(function () {
  if (window.__klaviyoNewsletterInit) return;
  window.__klaviyoNewsletterInit = true;

  var SITE_ID = 'WqzWP6';
  var LIST_ID = 'WF4XTC';

  function ready(fn) {
    if (document.readyState !== 'loading') { fn(); }
    else { document.addEventListener('DOMContentLoaded', fn); }
  }

  // UTM-Herkunft (z. B. QR-Code in der Galerie: utm_source=qr).
  // § 25 TDDDG: sessionStorage nur mit Statistik-Einwilligung lesen oder
  // schreiben (analyticsProcessingAllowed). Ohne Einwilligung gehen nur die
  // UTM-Parameter der AKTUELLEN URL mit der Anmeldung mit, ohne Speicherzugriff.
  // Mit Einwilligung: UTM der Landing-URL fuer die Sitzung merken; neue UTM in
  // derselben Sitzung ersetzen die alten. landing_path = Pfad ohne Query.
  var UTM_KEY = 'sonsu_signup_utm';
  var UTM_FIELDS = ['utm_source', 'utm_medium', 'utm_campaign'];

  function urlUtm() {
    try {
      var q = new URLSearchParams(window.location.search), u = {}, any = false;
      UTM_FIELDS.forEach(function (f) {
        var v = (q.get(f) || '').trim().slice(0, 100);
        if (v) { u[f] = v; any = true; }
      });
      if (!any) return null;
      u.landing_path = window.location.pathname;
      return u;
    } catch (e) { return null; }
  }
  var landingUtm = urlUtm();   // nur im Speicher der Seite

  function statsConsent() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      return !!(cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed());
    } catch (e) { return false; }
  }

  function persistUtm() {
    if (!landingUtm || !statsConsent()) return;
    try { window.sessionStorage.setItem(UTM_KEY, JSON.stringify(landingUtm)); } catch (e) {}
  }
  // Customer Privacy API ist beim Ausfuehren evtl. noch nicht da: erneut nach
  // load und sobald der Besucher im Banner entscheidet.
  persistUtm();
  window.addEventListener('load', persistUtm);
  document.addEventListener('visitorConsentCollected', function (e) {
    var d = (e && e.detail) || {};
    if (d.analyticsAllowed === true) { persistUtm(); return; }
    try { window.sessionStorage.removeItem(UTM_KEY); } catch (x) {}
  });

  function utmProps() {
    var u = urlUtm();
    if (!u && statsConsent()) {
      try { u = JSON.parse(window.sessionStorage.getItem(UTM_KEY) || 'null'); } catch (e) { u = null; }
    }
    if (!u) return {};
    return {
      signup_utm_source: u.utm_source, signup_utm_medium: u.utm_medium,
      signup_utm_campaign: u.utm_campaign, signup_landing_path: u.landing_path
    };
  }

  // GA4-Ziel "Kontakt/Newsletter". Gleiches Consent-Gate wie
  // assets/internal-click-tracking.js: window.gtag existiert erst nach
  // Statistik-Einwilligung, zusaetzlich analyticsProcessingAllowed().
  // Keine E-Mail, keine personenbezogenen Daten.
  function trackSignup(props) {
    if (typeof window.gtag !== 'function') return;
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && !cp.analyticsProcessingAllowed()) return;
    } catch (e) {}
    var p = { transport_type: 'beacon' };
    ['signup_source', 'signup_article', 'signup_cluster'].forEach(function (k) { if (props[k]) p[k] = props[k]; });
    try { window.gtag('event', 'newsletter_signup', p); } catch (e) {}
  }

  function subscribe(email, source, extraProps, onOk, onErr) {
    var props = { signup_source: source };
    if (extraProps) { for (var k in extraProps) { if (extraProps[k]) props[k] = extraProps[k]; } }
    var utm = utmProps();
    for (var u in utm) { if (utm[u]) props[u] = utm[u]; }
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: source,
          profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
        },
        relationships: { list: { data: { type: 'list', id: LIST_ID } } }
      }
    };
    fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + SITE_ID, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: '2025-01-15' },
      body: JSON.stringify(payload)
    }).then(function (r) {
      if (!r.ok) { onErr(); return; }
      markSubscribed(source);
      trackSignup(props);
      onOk();
    }).catch(onErr);
  }

  // Merker "hat sich angemeldet" (DOI angestossen) fuer Einblendungen wie das
  // Brief-Slide-in (assets/brief-slide-in.js), die Angemeldete nicht mehr stoeren.
  function markSubscribed(source) {
    try { window.localStorage.setItem('sonsu_brief_subscribed', String(Date.now())); } catch (e) {}
    try { document.dispatchEvent(new CustomEvent('sonsu:brief-subscribed', { detail: { source: source } })); } catch (e) {}
  }

  function newsletterSource(form) {
    if (form.closest('#newsletter-popup-overlay')) return 'header-popup';
    if (form.closest('.popup-wrap')) return 'popup';
    if (form.closest('.footer')) return 'footer';
    if (form.closest('.newsletter')) return 'newsletter-section';
    return 'newsletter';
  }

  function lang() { return (document.documentElement.lang || 'de').slice(0, 2); }

  function showThemeMessage(form, ok) {
    var en = lang() === 'en';
    var txt = ok
      ? (en ? 'Almost there. Check your inbox and confirm your subscription.'
            : 'Fast geschafft. Schau in dein Postfach und bestätige deine Anmeldung.')
      : (en ? 'That did not work. Please try again later.'
            : 'Hat nicht geklappt. Bitte später noch einmal versuchen.');
    var el = form.querySelector('[data-klaviyo-msg]');
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-klaviyo-msg', '');
      el.className = 'newsletter-form__message form__message';
      el.setAttribute('role', 'status');
      el.style.marginTop = '1rem';
      form.appendChild(el);
    }
    el.textContent = txt;
    el.style.color = ok ? '' : '#FF0777';
    if (ok) {
      var inner = form.querySelector('.newsletter-form__inner');
      if (inner) inner.style.display = 'none';
    }
  }

  ready(function () {
    // 1) "der Brief" units (two-step or direct)
    document.querySelectorAll('[data-brief-inline]').forEach(function (unit) {
      if (unit.dataset.klaviyoBound) return; unit.dataset.klaviyoBound = '1';
      var cta = unit.querySelector('[data-brief-cta]');
      var action = unit.querySelector('[data-brief-action]');
      var form = unit.querySelector('[data-brief-form]');
      var email = unit.querySelector('[data-brief-email]');
      var success = unit.querySelector('[data-brief-success]');
      var error = unit.querySelector('[data-brief-error]');
      var submitBtn = form ? form.querySelector('[type="submit"]') : null;
      if (!form || !email) return;

      if (cta) cta.addEventListener('click', function () {
        if (action) action.hidden = true;
        form.hidden = false;
        email.focus();
      });

      var source = unit.dataset.source || 'inline-content';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var value = email.value.trim();
        if (!value) return;
        if (error) error.hidden = true;
        if (submitBtn) submitBtn.disabled = true;
        subscribe(value, source,
          { signup_article: unit.dataset.article || '', signup_cluster: unit.dataset.cluster || '' },
          function () { form.hidden = true; if (success) success.hidden = false; },
          function () { if (error) error.hidden = false; if (submitBtn) submitBtn.disabled = false; });
      });
    });

    // 2) Theme newsletter forms (Shopify-Customer-Markup) -> Klaviyo DOI, kein Shopify-Submit
    document.querySelectorAll('form.newsletter-form').forEach(function (form) {
      if (form.closest('[data-brief-inline]')) return;     // schon oben behandelt
      if (form.dataset.klaviyoBound) return; form.dataset.klaviyoBound = '1';
      var email = form.querySelector('input[type="email"]');
      if (!email) return;
      var submitBtn = form.querySelector('[type="submit"]');
      var source = newsletterSource(form);

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var value = email.value.trim();
        if (!value) return;
        if (submitBtn) submitBtn.disabled = true;
        subscribe(value, source, null,
          function () { showThemeMessage(form, true); },
          function () { showThemeMessage(form, false); if (submitBtn) submitBtn.disabled = false; });
      });
    });
  });
})();
